import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { getIconPath } from 'src/utils/assetPaths';
const CLOSE = getIconPath('icons-24-close.svg');

const { responsiveText, spacing } = theme;

export const header = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${spacing.xl}px ${spacing.md}px;
  border-bottom: 1px solid var(--neutral-black-10);

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      padding: ${spacing.xl}px;
    `,
  )}
`;

export const closeButton = css`
  width: 24px;
  height: 24px;
  padding: 0;
  display: block;
  text-align: left;
  border: none;
  background-color: transparent;
  background-image: url(${CLOSE});
  background-repeat: no-repeat;
  background-position: right;
  cursor: pointer;
`;

export const section = css`
  box-shadow: -4px 0 8px 0 rgba(0, 0, 0, 0.2);
  padding: 0;
  position: fixed;
  background: var(--neutral-white-base);
  top: 0;
  right: 0;
  height: 100%;
  min-width: 100%;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      min-width: 0;
    `,
  )};
`;

export const content = css`
  padding: ${spacing.xl}px ${spacing.md}px;
  overflow-y: auto;
  max-height: calc(100% - 76px); // 76px is the height of the header
  display: flex;
  gap: ${spacing.xl}px;
  flex-direction: column;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      padding: ${spacing.xl}px;
    `,
  )}
`;

export const message = css`
  ${responsiveText.BODY.MD};
  color: var(--brand-bluple-base);
  text-align: center;
`;
